import React from 'react';
import IDs from '@constants/componentIds';
import PanDetails from '@components/PanDetails';
import BusinessDetails from '@components/BusinessDetails';
import BankDetails from '@components/BankDetails';
import SigningAuthority from '@components/SigningAuthority';
import KYCComponent from '@components/KYC';
import WebsiteDetails from '@components/WebsiteDetails';
import AdditionalUploadForm from '@components/ManualUpload/AdditionalUploadForm';
import ServiceAgreement from '@components/ServiceAgreement';

import WebsiteCommentForm from '@components/Comments/Website';
import BankComment from '@components/Comments/Bank';

const PAN = {
  default: {
    component: <PanDetails />,
    content: {
      inComplete: {
        title: 'PAN verification',
        description:
          'Verify your PAN details & get started with your account.',
      },
      completed: {
        title: 'Your PAN is verified. Way to Go!',
        description:
          'Now, complete the Step 2 & 3 for payment settlements directly in your bank account.',
      },
      why: {
        heading: 'Why we need PAN',
        body: 'Permanent Account Number (PAN) is mandatory to make any monetary transaction online as per the latest RBI guidelines.',
      },
      stepIcon: '../../../assets/images/onboarding/lock-open.svg',
    },
  },
};

const BUSINESS_DETAILS = {
  default: {
    component: <BusinessDetails />,
    content: {
      inComplete: {
        title: 'Tell us a little bit about your business',
        description: 'This will help us recommend the best payment solutions for your business.',
      },
      completed: {
        title: 'Business details submitted successfully!',
        description: 'You are a few steps away from activating your account.',
      },
      why: {
        body: 'Your business details help us recommend the right payment products based on your needs.',
      },
      stepIcon: '../../../assets/images/onboarding/shop-icon.svg',
    },
  },
};

const BANK_DETAILS = {
  default: {
    component: <BankDetails />,
    headerTop: <BankComment />,
    content: {
      inComplete: {
        title: `
          Enter Bank details 
          {{#pancard_name}}
           of {{pancard_name}}
          {{/pancard_name}}
          {{#bank_verification_in_progress}}
           {{{verification_badge}}}
          {{/bank_verification_in_progress}}
          {{#bank_verification_failed}}
            {{{verification_failed_badge}}}
          {{/bank_verification_failed}}
          {{#bank_verification_attempts_exhausted}}
            {{{verification_attempts_exhausted_badge}}}
          {{/bank_verification_attempts_exhausted}}
        `,
        description: 'We will make settlements to the following account for the money received from your customers.',
      },
      completed: {
        title: 'Bank account connected',
        description: 'Great! We’ll settle your transactions to this account once you complete all the on-boarding steps.',
      },
      why: {
        body: 'We need your bank details to settle the money into your bank account. However note that you would need to complete all remaining steps before you can receive money in your account.',
      },
      stepIcon: '../../../assets/images/onboarding/bank-icon.svg',
    },
  },
};

const WEBSITE_DETAILS = {
  default: {
    component: <WebsiteDetails />,
    // headerBottom: <WebsiteCommentForm />,
    content: {
      inComplete: {
        title: 'How do you wish to accept payments',
        description: 'Help us with your website or App details, if you have one.',
      },
      completed: {
        title: 'Payment acceptance modes verified',
        description: 'Thanks for letting us know how you would collect payments.',
      },
      why: {
        body: 'You can accept payments only on the website/ app URL specified by you here. You can update this later.',
      },
      stepIcon: '../../../assets/images/onboarding/website-icon.svg',
    },
  },
};

const SIGINING_AUTHORITY = {
  default: {
    component: <SigningAuthority />,
    content: {
      inComplete: {
        title: 'Verify signing authority details',
        description: 'Let us know the authorised signatory for your account.',
      },
      completed: {
        title: 'Signing authority details captured',
        description: 'Thanks for letting us know the authorised signatory for your account.',
      },
      why: {
        body: 'We would need to perform a KYC of signing authority in the subsequent steps.',
      },
      stepIcon: '../../../assets/images/onboarding/authority-icon.svg',
    },
  },
};

const KYC = {
  default: {
    component: <KYCComponent />,
    content: {
      inComplete: {
        title: `
          Complete the KYC 
          {{#signing_authority_name}}
          for {{signing_authority_name}}
          {{/signing_authority_name}}
        `,
        description: 'Please select among multiple options to complete the KYC.',
      },
      completed: {
        title: 'KYC completed',
        description: 'Thanks for providing your KYC information.',
      },
      why: {
        body: 'We need to verify the KYC information provided by you.',
      },
      stepIcon: '../../../assets/images/onboarding/kyc-icon.svg',
    },
  },
};

const AdditionalDocuments = {
  default: {
    component: <AdditionalUploadForm />,
    // footer: <ServiceAgreement />,
    content: {
      inComplete: {
        title: 'Additional documents required',
        description: 'We need a few more documents to complete you KYC and activate your account.',
      },
      completed: {
        title: 'KYC documents verified',
        description: 'We have successfully verified your KYC details.',
      },
      why: {
        body: 'We need certain documents to verify your KYC details.',
      },
      stepIcon: '../../../assets/images/onboarding/doc-icon.svg',
    },
  },
};

const SERVICE_AGREEMENT = {
  default: {
    component: <ServiceAgreement />,
    content: {
      inComplete: {
        title: 'E sign Service Agreement',
        description: 'Transact limit free by signing the service agreement.',
      },
      completed: {
        title: 'E sign Service Agreement Complete',
        description: 'Transact limit free.'
      },
      locked: {
        // conditional: 'We are reviewing your KYC information. We will share your service agreement once approved.',
      },
      stepIcon: '../../../assets/images/onboarding/agreement-icon.svg',
    },
  },
};

const COMPONENTS = {
  [IDs.panDetails.default]: PAN.default,
  [IDs.businessDetails.default]: BUSINESS_DETAILS.default,
  [IDs.bankDetails.default]: BANK_DETAILS.default,
  [IDs.websiteDetails.default]: WEBSITE_DETAILS.default,
  [IDs.signingAuthority.default]: SIGINING_AUTHORITY.default,
  [IDs.kyc.default]: KYC.default,
  [IDs.additionalDocuments.default]: AdditionalDocuments.default,
  [IDs.serviceAgreement.default]: SERVICE_AGREEMENT.default,
};

export default COMPONENTS;
